// extracted by mini-css-extract-plugin
export default {"hyperlink":"EditorExtension_Count_hyperlink__4lifv"};